'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var asterisk = require('./asterisk-436ee6b3.js');

var Title = styled__default.label(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  display: inline-block;\n  font-weight: normal;\n  font-style: normal;\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  display: inline-block;\n  font-weight: normal;\n  font-style: normal;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts[0];
});
var Required = styled__default.span(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  padding-left: 4px;\n  font-size: 6px;\n  position: relative;\n  top: -4px;\n"], ["\n  color: ", ";\n  padding-left: 4px;\n  font-size: 6px;\n  position: relative;\n  top: -4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.admin.pink;
});
var AsteriskStyled = styled__default(asterisk.Asterisk)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font-weight: 900;\n  font-size: 12px;\n"], ["\n  font-weight: 900;\n  font-size: 12px;\n"])));
var CalendarInputTitle = function (_a) {
    var required = _a.required, dateTitle = _a.dateTitle, dataCy = _a.dataCy, dataTestId = _a.dataTestId, readOnly = _a.readOnly;
    var allowTitle = dateTitle && required;
    return (React__default.createElement(Title, { htmlFor: "datePicker" },
        dateTitle,
        !readOnly ? (allowTitle
            && (React__default.createElement(Required, { "data-cy": dataCy + "DatePickerAsterisk", "data-testid": dataTestId && dataTestId + "-asterisk" },
                React__default.createElement(AsteriskStyled, null)))) : ':'));
};
var templateObject_1, templateObject_2, templateObject_3;

exports.CalendarInputTitle = CalendarInputTitle;
